module.exports = __webpack_public_path__ + "img/Pl5_icon.d96d6d09.png";